import {alertMessages} from '_constants';
import {SnackBar} from "../components/common";
import {billingConstants} from "../_constants/billing.constants";
import {billingService} from "../_services/billing.service";

export const billingActions = {
    getBillingSettingsLink,
    getBillingsSummary,
    getOrganizationBillingBreakdown
};

function getBillingSettingsLink() {
    return dispatch => {
        dispatch(request());

        billingService.getBillingSettingsLink()
            .then(
                response => {
                    dispatch(success(response))
                    window.open(response.url, '_blank', 'noopener,noreferrer');
                },
                error => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.BILLING_SETTINGS_ERROR)
                }
            );
    };

    function request() {
        return {type: billingConstants.GET_BILLING_SETTINGS_REQUEST}
    }

    function success(url) {
        return {type: billingConstants.GET_BILLING_SETTINGS_SUCCESS, url}
    }

    function failure(error) {
        return {type: billingConstants.GET_BILLING_SETTINGS_FAILURE, error}
    }
}

function getBillingsSummary(params) {
    return dispatch => {
        dispatch(request());

        billingService.getBillingsSummary(params)
            .then(
                response => {
                    dispatch(success(response))
                },
                error => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.GENERIC_ERROR)
                }
            );
    };

    function request() {
        return {type: billingConstants.GET_BILLING_SUMMARY_REQUEST}
    }

    function success(payload) {
        return {type: billingConstants.GET_BILLING_SUMMARY_SUCCESS, payload}
    }

    function failure(error) {
        return {type: billingConstants.GET_BILLING_SUMMARY_FAILURE, error}
    }
}

function getOrganizationBillingBreakdown(params) {
    return dispatch => {
        dispatch(request());

        billingService.getOrganizationBillingBreakdown(params)
            .then(
                response => {
                    dispatch(success(response))
                },
                error => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.GENERIC_ERROR)
                }
            );
    };

    function request() {
        return {type: billingConstants.GET_ORGANIZATION_BILLINGS_REQUEST}
    }

    function success(payload) {
        return {type: billingConstants.GET_ORGANIZATION_BILLINGS_SUCCESS, payload}
    }

    function failure(error) {
        return {type: billingConstants.GET_ORGANIZATION_BILLINGS_FAILURE, error}
    }
}